<template>
    <div class="right author-right pt0">
        <chapterTip>
            <div slot="tip-name">{{$lang('authorCenter.stories.contractSign[0]')}}</div>
            <div slot="tip-con">
                {{$lang('authorCenter.stories.deleteStory[0]')}}
            </div>
            <div slot="tip-btn">
                <el-button v-if="bookdetail.open" class="f16 font-MT" disabled type="info" size="medium">{{$lang('authorCenter.stories.submit')}}</el-button>
                <el-button v-if="!bookdetail.open" class="f16 font-MT" size="medium" @click="closesure(true)">{{$lang('authorCenter.stories.submit')}}</el-button>
            </div>
        </chapterTip>
        <surePop v-if="isDel" @closesure="closesure">
            <div slot="surecon">
                <div class="title flexible aItem-center jc-center f20 text-333 font-MT">
                    {{$lang('authorCenter.stories.infoTips')}}
                </div>
                <div class="surecon-detail f18 text-333 flexible aItem-center jc-center">
                    <div class="text-line36">
                        {{$lang('authorCenter.stories.deleteStory[1]')}}
                    </div>
                </div>
            </div>
            <div slot="optionbox" class="btn-item flexible jc-center">
                <el-button size="medium" class="f16 font-MT ml20" @click="deletebook">{{$lang('authorCenter.stories.confirm')}}</el-button>
                <el-button size="medium" class="el-button-opa f16 font-MT ml24" @click="closesure(false)">{{$lang('authorCenter.stories.cancel')}}</el-button>
            </div>
        </surePop>
    </div>
</template>

<script>
    import { delectbook } from 'apiurl/author';
    import Surepop from "../../../components/inc/surepop";
    export default {
        name: "",
        components: {Surepop},
        data () {
            return{
                isDel: false,
            }
        },
        props: {
            bookdetail: Object
        },
        watch: {
            bookdetail (n) {
                console.log(this.bookdetail)
            }
        },
        methods: {
            deletebook() {
                delectbook(this.$route.params.id)
                    .then(res => {
                        if (res.success) {
                            this.closesure()
                            this.$success('del')
                            this.$router.push('/author');
                        }
                    })
                    .catch(() => {});
            },
            closesure (data) {
                this.isDel = data
                this.$emit('changePop', data)
            },
        }
    }
</script>

<style scoped>

</style>
